import { useSdk } from '~/sdk';

export const useHeaderMenu = () => {
  const nuxtApp = useNuxtApp();
  const { locale } = useI18n();

  const menu = useLazyAsyncData(`menu-header-${locale.value}`, async () => {
    return await useSdk().cms.getContent({
      entries: {
        section: 'menuHeader',
        fragment: `
          title,
          ... on default_Entry {
            slug
            callToAction {
              title
              target
              url
              element {
                id
                slug
                siteId
              }
            }
          }
        `,
      },
    });
  });

  watch(nuxtApp.$i18n.locale, () => {
    menu.refresh();
  });

  return {
    menu: computed(() => menu.data.value ?? []),
  };
};
